import isAppWebView from '../../../../../config/isAppWebView';
import {CommonLink} from '../../../../../shared/components/CommonLink';

export const WpEditLink: React.FC<{
  columnId: string;
}> = ({columnId}) => {
  return (
    !isAppWebView() && (
      <div className="bg-white px-16">
        ・
        <CommonLink
          href={`/wp-admin/post.php?post=${columnId}&action=edit`}
          className="text-link text-base leading pc:hover:underline"
          target="_blank"
        >
          この記事を編集する
        </CommonLink>
      </div>
    )
  );
};
